import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import NetworkDeviceContentAddItemSwitcherForm from "../_forms/NetworkDeviceContentAddItemSwitcherForm";
import {connect} from "react-redux";
import {v4 as uuidv4} from "uuid";
import NetworkDeviceContentSwitcherTable from "./NetworkDeviceContentSwitcherTable";

class NetworkDeviceContentSwitcher extends Component {

    state = {
        selectedItem: null,
        switcherParams: [],
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.selectedItem !== null && prevState.selectedItem?.switcherItems !== this.state.selectedItem?.switcherItems)
        {
            console.log('------------------------------');
            console.log('logger');
            console.log('------------------------------');
        }
    }

    handleAddItemModel = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add-launcher-item'),
            component: <NetworkDeviceContentAddItemSwitcherForm
                selected={this.props.switcherItems}
                networkDeviceId={this.props.networkDeviceId}
                submit={(data) => this.handleSaveSelectedItem(data)}
            />
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}));
    }

    handleSaveSelectedItem = (data) => {
        const { dispatch } = this.props;
        data.forEach((item, idx) => {
            item._id = uuidv4();
            item.switcherContentParams = {
                networkDeviceContentId: item.id,
                order: idx,
                key: "",
                resetOnSwitch: false,
                killAfterSwitch: false,
                onStartup: false
            }
        });
        dispatch(modalActions.hideModal());
        this.props.setSwitcherItems([...data]);
    };

    handleDeleteItem = (data) => {
        const { dispatch } = this.props;
        dispatch(modalActions.hideModal());

        this.props.edit?
            this.props.setSwitcherItems(this.props.switcherItems.filter((item,i) => item.id !== data.id)) :
            this.props.setSwitcherItems(this.props.switcherItems.filter((item,i) => item._id !== data._id));
    }

    handleSelected = (data) => {
        data !== null ?
            this.setState({...this.state, selectedItem: data }):
            this.setState({...this.state, selectedItem: null});
    };

    render() {
        const { t, switcherItems, show } = this.props;
        return (
            show ? (
                <div className="card col-md-12">
                    <div className="card-header">
                        <p className="card-title">
                            { t('switcher-content-list') }
                        </p>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <Button
                                    type={"button"}
                                    variant={"primary"}
                                    size={"sm"}
                                    onClick={(e) => this.handleAddItemModel(e)}
                                >
                                    <i className="fas fa-plus-circle"/> &nbsp;
                                    {t('add-item')}
                                </Button>

                                <NetworkDeviceContentSwitcherTable
                                    list={switcherItems}
                                    getSelected={this.handleSelected}
                                    deleteItem={this.handleDeleteItem}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (<></>)
        );
    }
}
const mapStateToProps = (state) => {
    return state;
}
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentSwitcher));
